import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER,

    TrialInstitutionLaboratoryPersonnelAction
} from '../actions/trialInstitutionLaboratoryPersonnels';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialInstitutionLaboratoryPersonnelState {
    formData: Dtos.TrialInstitutionLaboratoryPersonnel | Dtos.TrialInstitutionLaboratoryPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionLaboratoryPersonnel[];
    formLength: number;
}

const initialState: ITrialInstitutionLaboratoryPersonnelState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialInstitutionLaboratoryPersonnelState, _isLoading: boolean): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialInstitutionLaboratoryPersonnelState,
    formData: Dtos.TrialInstitutionLaboratoryPersonnel | Dtos.TrialInstitutionLaboratoryPersonnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: ITrialInstitutionLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: ITrialInstitutionLaboratoryPersonnelState, formFilter: IFormFilter): ITrialInstitutionLaboratoryPersonnelState {

    const items: Dtos.TrialInstitutionLaboratoryPersonnel[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.personnel?.displayWithSalutation?.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionLaboratoryPersonnelState, propertiesToClear?: string[]): ITrialInstitutionLaboratoryPersonnelState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionLaboratoryPersonnelState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialInstitutionLaboratoryPersonnelState, _isSaving: boolean): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionLaboratoryPersonnelState,
    formData: Dtos.TrialInstitutionLaboratoryPersonnel | Dtos.TrialInstitutionLaboratoryPersonnel[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionLaboratoryPersonnelState, _isCreating: boolean): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionLaboratoryPersonnelState,
    formData: Dtos.TrialInstitutionLaboratoryPersonnel,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialInstitutionLaboratoryPersonnelState, _isValidating: boolean): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialInstitutionLaboratoryPersonnelState,
    formData: Dtos.TrialInstitutionLaboratoryPersonnel,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialInstitutionLaboratoryPersonnelState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryPersonnelState {
    const newState: ITrialInstitutionLaboratoryPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialInstitutionLaboratoryPersonnelReducer: Reducer<ITrialInstitutionLaboratoryPersonnelState> = (state: ITrialInstitutionLaboratoryPersonnelState = initialState, action: TrialInstitutionLaboratoryPersonnelAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD:
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID:
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialInstitutionLaboratoryPersonnelReducer;